import type { JSX } from "react";
import cn from "classnames";

interface SkillRatingBarProps {
  actualValue: number;
  expectedValue: number;
  maxValue?: number;
  className?: string;
}

export const SkillRatingBar = (props: SkillRatingBarProps): JSX.Element => {
  const { actualValue, expectedValue, maxValue = 5, className } = props;

  const actualPercent = (actualValue / maxValue) * 100;
  const expectedPercent = (expectedValue / maxValue) * 100;

  const barColor = actualValue >= expectedValue ? "bg-[#AFF4C6]" : "bg-[#FCB3AD]";
  const actualLineColor = actualValue >= expectedValue ? "bg-[#14AE5C]" : "bg-[#EC2320]";

  return (
    <div className={cn("relative h-4 bg-gray-100", className)}>
      <div
        className={cn("absolute top-0 bottom-0 left-0 transition-all duration-500 ease-in-out", barColor)}
        style={{ width: `${actualPercent}%` }}
      />
      <div
        className="absolute top-0 bottom-0 z-10 w-px bg-slate-700 transition-all duration-500 ease-in-out"
        style={{ left: `${expectedPercent}%` }}
      />
      <div
        className={cn("absolute top-0 bottom-0 z-20 w-px transition-all duration-500 ease-in-out", actualLineColor)}
        style={{ left: `${actualPercent}%` }}
      />
    </div>
  );
};
